\<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 사업장 -->
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <!-- <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-text
            label="설치지역"
            name="installLocation"
            v-model="searchParam.installLocation">
          </c-text>
        </div> -->
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <!-- 관련공정 -->
          <c-process
            label="LBL0001705"
            multiple="single"
            name="processCd"
            v-model="searchParam.processCd">
          </c-process>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <!-- 관리부서 -->
          <c-dept
            type="search"
            label="LBL0001721"
            name="deptCd"
            v-model="searchParam.deptCd">
          </c-dept>
        </div>
      </template>
    </c-search-box>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <!-- 화재탐지 및 경보설비 설치계획 목록 -->
        <c-table
          ref="firedetection"
          title="LBL0010518"
          tableId="firedetection"
          :columns="grid.columns"
          :gridHeight="grid.height"
          :data="grid.data"
          rowKey="fireDetectionId"
          :columnSetting="false"
          :expandAll="true"
          @linkClick="linkClick"
        >
          <!-- 버튼 영역 -->
          <template slot="table-button">
            <q-btn-group outline >
              <!-- 등록 -->
              <c-btn v-if="editable" label="LBLREG" icon="add" @btnClicked="equipmentPopup" />
              <!-- 검색 -->
              <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
            </q-btn-group>
          </template>
        </c-table>
      </div>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'fire-detection',
  data() {
    return {
      grid: {
        columns: [
          {
            name: 'plantName',
            field: 'plantName',
            // 사업장
            label: 'LBLPLANT',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
          {
            name: 'revisionNum',
            field: 'revisionNum',
            label: 'Rev.',
            align: 'center',
            style: 'width:50px',
            sortable: true,
          },
          {
            name: 'installLocation',
            field: 'installLocation',
            // 설치지역
            label: 'LBL0010501',
            style: 'width:150px',
            align: 'center',
            type: 'link',
            sortable: true,
          },
          {
            name: 'singleAlarm',
            field: 'singleAlarm',
            // 단독경보형감지기
            label: 'LBL0010519',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
          {
            name: 'emergencyAlarm',
            field: 'emergencyAlarm',
            // 비상경보설비
            label: 'LBL0010520',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
          {
            name: 'startAlarm',
            field: 'startAlarm',
            // 시작경보기
            label: 'LBL0010521',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
          {
            name: 'autoDetection',
            field: 'autoDetection',
            // 자동화재탐지설비
            label: 'LBL0010522',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
          {
            name: 'emergencyBroadcast',
            field: 'emergencyBroadcast',
            // 비상방송설비
            label: 'LBL0010523',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
          {
            name: 'autoBreakingnews',
            field: 'autoBreakingnews',
            // 자동화재속보설비
            label: 'LBL0010524',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
          {
            name: 'integrationSystem',
            field: 'integrationSystem',
            // 통합감시시설
            label: 'LBL0010525',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
          {
            name: 'shortAlarm',
            field: 'shortAlarm',
            // 누전경보기
            label: 'LBL0010526',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
        ],
        data: [],
      },
      searchParam: {
        plantCd: '',
        installLocation: '',
        processCd: '',
        deptCd: '',
      },
      editable: true,
      listUrl: '',
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        top: '',
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      // api scope
      this.listUrl = selectConfig.psi.lbe.firedetect.list.url;
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    linkClick(row) {
      this.equipmentPopup(row);
    },
    equipmentPopup(result) {
      this.popupOptions.target = () => import(`${"./fireDetectionAlarmSystemInfoDetail.vue"}`);
      this.popupOptions.title = 'LBL0010527'; // 화재탐지 및 경보설비 설치계획 상세
      this.popupOptions.param = {
        fireDetectionId: result ? result.fireDetectionId : '',
      };
      this.popupOptions.width = '80%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
  }
};
</script>
